import {action, observable} from 'mobx';

class RowViewModel {
  @observable data;
  @observable parent;
  @observable isExpanded = false;
  @observable isLoading = false;

  constructor(data, parent = null) {
    this.data = data;
    this.parent = parent;
  }

  @action expand() {
    this.isExpanded = true;
  }

  @action collapse() {
    this.isExpanded = false;
  }

  @action setLoading(loading) {
    this.isLoading = loading;
  }
}

export default RowViewModel;
